{
  "documents": {
    "title": "Coffre-fort Numérique",
    "subtitle": "Gestion de vos actifs institutionnels et juridiques.",
    "actions": {
      "generate_statutes": "Générer Statuts",
      "upload": "Charger",
      "view": "Voir",
      "download": "Télécharger",
      "share": "Partager",
      "delete": "Supprimer",
      "request_doc": "Demander Document"
    },
    "filters": {
      "all": "Tous les Documents",
      "legal": "Juridique & Statuts",
      "finance": "Documents Financiers",
      "tax": "Déclarations Fiscales",
      "hr": "Ressources Humaines",
      "administrative": "Administratif"
    },
    "search": "Rechercher un document...",
    "table": {
      "name": "Nom du Document",
      "type": "Type",
      "date": "Date d'ajout",
      "status": "Statut",
      "size": "Taille"
    },
    "status": {
      "verified": "Vérifié",
      "pending": "Audit en cours",
      "draft": "Brouillon",
      "expired": "Expiré",
      "archived": "Archivé"
    },
    "empty": {
      "title": "Aucun document trouvé",
      "subtitle": "Téléchargez votre premier document ou générez des statuts pour commencer.",
      "cta": "Charger un Document"
    },
    "upload": {
      "title": "Charger un Document",
      "dropzone": "Cliquez ou glissez un fichier ici pour le charger",
      "hint": "Support PDF, JPG, PNG (Max 10Mo)",
      "processing": "Analyse de la structure du document...",
      "success": "Document chargé et indexé."
    }
  },
  "common": {
    "not_defined": "Non Défini",
    "not_available": "N/A",
    "previous": "Précédent",
    "back": "Retour",
    "next": "Suivant",
    "save": "Enregistrer",
    "processing": "Traitement...",
    "saved": "Enregistré",
    "export_success": "Rapport exporté avec succès",
    "currency": "DA",
    "error": {
      "title": "Erreur Critique du Système",
      "description": "Le module n'a pas pu être chargé correctement. Détail technique :",
      "reset": "Réinitialiser le Module"
    },
    "link_copied": "Lien copié dans le presse-papier",
    "loading": "Chargement...",
    "confirm": "Confirmer",
    "new": "Nouveau",
    "locale": "fr-FR",
    "options": {
      "cancel": "Annuler",
      "yes": "YES",
      "no": "NO",
      "confirm": "Confirm",
      "retry": "Retry"
    }
  },
  "dashboard": {
    "title": "Gestion d'Entreprise",
    "subtitle": "Pilotage stratégique pour l'entreprise moderne.",
    "pdf": {
      "title": "DOSSIER JURIDIQUE DE L'ENTREPRISE",
      "date": "Date",
      "ref": "Référence",
      "sections": {
        "identity": "1. IDENTITÉ DE LA SOCIÉTÉ",
        "governance": "2. GOUVERNANCE & STRUCTURE",
        "history": "HISTORIQUE DES ACTIONS JURIDIQUES"
      },
      "table": {
        "field": "Champ",
        "info": "Information",
        "role": "Rôle",
        "entity_person": "Entité/Personne",
        "status": "Statut",
        "date": "Date",
        "action_type": "Type d'Action",
        "summary": "Résumé"
      },
      "fields": {
        "legal_name": "Dénomination",
        "legal_form": "Forme Juridique",
        "nif": "NIF",
        "rc": "RC",
        "capital": "Capital Social",
        "headquarters": "Siège Social",
        "manager": "Gérant",
        "associates": "Associés",
        "active": "Actif",
        "registered": "Enregistré",
        "members": "{{count}} Membres"
      },
      "defaults": {
        "modification": "Modification statutaire enregistrée.",
        "ledger": "Acte officiel répertorié."
      },
      "filename_suffix": "dossier"
    },
    "errors": {
      "address_required": "L'adresse exacte est requise",
      "capital_invalid": "Montant du capital invalide",
      "form_required": "Sélectionnez une forme juridique valide",
      "name_required": "Nom de l'associé requis",
      "confirm_dissolution": "Veuillez confirmer la décision de dissolution",
      "confirm_liquidation": "Veuillez confirmer la clôture de liquidation"
    },
    "stats": {
      "title": "Indicateurs Clés",
      "age": "Ancienneté",
      "compliance": "Conformité",
      "active_projects": "Projets Actifs",
      "compliance_rate": "Taux de Conformité",
      "legal_events": "Événements Juridiques",
      "next_audit": "Prochain Audit",
      "legal_form": "Forme Juridique",
      "capital": "Capital Social",
      "governance": "Gouvernance",
      "location": "Localisation",
      "active_associates": "Associés Actifs",
      "official_identity": "Identité Officielle",
      "verified_registry": "Vérifié au Registre National du Commerce",
      "tax_status": "Fiscalité G50 À Jour",
      "legal_status": "Statuts Authentifiés",
      "years": "{{count}} Ans",
      "established": "Établi",
      "secure": "Sécurisé",
      "no_manager": "Pas de Gérant"
    },
    "grid": {
      "simulator": {
        "title": "Simulateur Fiscal & Social",
        "desc": "Simulez et optimisez votre structure avant le lancement."
      },
      "name_check": {
        "title": "Validation de Marque",
        "desc": "Vérifiez la disponibilité et les risques de conflits légaux."
      },
      "create": {
        "title": "Création d'Entreprise",
        "desc": "Workflow unifié pour les démarches administratives et légales."
      },
      "documents": {
        "title": "Corporate Vault",
        "desc": "Accédez et gérez tous vos documents institutionnels."
      }
    },
    "journal": {
      "title": "Journal de l'Entreprise",
      "empty": "Aucun événement enregistré"
    },
    "actions": {
      "search_placeholder": "Rechercher une action juridique...",
      "download_dossier": "Dossier Numérique (PDF)",
      "hq_transfer": {
        "title": "Transfert de Siège",
        "desc": "Changement officiel d'adresse légale."
      },
      "capital_update": {
        "title": "Variation de Capital",
        "desc": "Augmentation ou réduction du capital social."
      },
      "form_change": {
        "title": "Changement de Forme",
        "desc": "Conversion en SARL, SPA ou EURL."
      },
      "manager_update": {
        "title": "Nomination de Gérant",
        "desc": "Changement ou renouvellement de la gérance."
      },
      "dissolution": {
        "title": "Dissolution de Société",
        "desc": "Décision formelle de cessation d'activité."
      },
      "liquidation": {
        "title": "Radiation & Liquidation",
        "desc": "Fermeture définitive et radiation."
      },
      "associates": {
        "title": "Gestion des Associés",
        "desc": "Mise à jour de l'actionnariat et entrées."
      },
      "object": {
        "title": "Objet Social",
        "desc": "Modifier les activités de l'entreprise."
      },
      "cnrc_portal": "Portail CNRC"
    },
    "legal": {
      "title": "Opérations Légales"
    },
    "vault": {
      "title": "Coffre-fort d'Entreprise"
    },
    "toasts": {
      "titles": {
        "success": "Succès",
        "error": "Erreur",
        "info": "Information",
        "warning": "Avertissement"
      },
      "generating_pdf": "Synchronisation des données et génération du PDF...",
      "pdf_success": "Dossier juridique exporté avec succès.",
      "pdf_error": "Échec de la génération du dossier numérique.",
      "hq_transfer_success": "Transfert de siège enregistré.",
      "capital_update_success": "Variation de capital confirmée.",
      "form_change_success": "Forme juridique mise à jour avec succès.",
      "manager_update_success": "Nomination du gérant enregistrée.",
      "dissolution_success": "Acte de dissolution généré.",
      "liquidation_success": "Liquidation terminée.",
      "associates_success": "Registre des associés mis à jour.",
      "object_success": "Modification de l'objet social enregistrée.",
      "action_error": "Une erreur est survenue lors du traitement.",
      "load_failed": "Impossible de synchroniser les données de l'entreprise.",
      "wizard_success": "Procédure juridique enregistrée et historique mis à jour.",
      "wizard_error": "Une erreur est survenue lors de l'exécution de la procédure."
    },
    "events": {
      "title": "Centre d'Action",
      "journal": "Journal",
      "view_all": "Tout Voir",
      "no_history": "Aucun historique disponible",
      "types": {
        "compliance": "Conformité",
        "tax": "Fiscalité",
        "security": "Sécurité",
        "creation": "Immatriculation Initiale",
        "capital_increase": "Augmentation de Capital",
        "headquarters_transfer": "Transfert de Siège",
        "legal_form_change": "Changement de Forme",
        "partner_addition": "Ajout d'Associé",
        "manager_update": "Changement de Gérant",
        "associates_update": "Mise à jour Associés",
        "dissolution": "Décision de Dissolution",
        "liquidation_started": "Liquidation Ouverte",
        "liquidation_completed": "Radiation Confirmée",
        "certificate_generation": "Émission de Document"
      },
      "descriptions": {
        "creation": "Immatriculation initiale.",
        "capital_increase": "Capital: {{amount}} DZD",
        "headquarters_transfer": "Siège: {{address}}",
        "legal_form_change": "Forme: {{form}}",
        "partner_addition": "Nouvel Associé: {{name}}",
        "manager_update": "Nouveau Gérant: {{name}}",
        "associates_update": "Structure de l'actionnariat mise à jour ({{count}} associés).",
        "dissolution": "Décision de dissolution.",
        "liquidation_started": "Entrée en phase de liquidation.",
        "liquidation_completed": "Radiation confirmée.",
        "certificate_generation": "Certificat officiel émis."
      },
      "statuses": {
        "completed": "Terminé",
        "pending": "En attente",
        "draft": "Brouillon",
        "active": "Actif",
        "archived": "Archivé"
      }
    },
    "loading": {
      "engine": "Synchronisation du Moteur Juridique..."
    },
    "statuses": {
      "liquidation": "Liquidation",
      "dissolved": "Dissoute",
      "active": "Actif"
    },
    "empty_state": {
      "title": "Aucune Entité Juridique Détectée",
      "description": "Vous devez avoir une entreprise active pour accéder au <1>Gestionnaire de Cycle de Vie Juridique</1>.",
      "cta": "Créer une entreprise"
    },
    "wizard": {
      "steps": {
        "structure": "Structure & Capital",
        "review": "Révision & Validation",
        "execution": "Confirmer & Exécuter"
      },
      "messages": {
        "finalizing": "Finalisation de la procédure et mise à jour du registre..."
      },
      "fields": {
        "configuration": "Configuration de l'Action",
        "new_address": "Nouvelle Adresse Légale",
        "address": "Nouvelle Adresse",
        "address_placeholder": "Saisir l'adresse complète",
        "wilaya": "Ville / Wilaya",
        "wilaya_placeholder": "Alger",
        "type": "Type",
        "lease": "Bail Commercial",
        "property": "Propriété",
        "new_capital": "Nouveau Capital Social (DZD)",
        "new_form": "Nouvelle Forme Juridique",
        "new_manager": "Nom du Nouveau Gérant",
        "capital_placeholder": "ex: 1 000 000",
        "current": "Actuel",
        "fullname": "Nom Complet",
        "fullname_placeholder": "Nom et Prénom",
        "shares": "Parts (%)",
        "shares_placeholder": "25",
        "role": "Rôle",
        "associate": "Associé",
        "manager": "Gérant",
        "director_general": "Directeur Général",
        "default_reason": "Décision unanime des associés",
        "default_wilaya": "Alger",
        "legal_form_desc": {
          "SARL": "Plusieurs Associés",
          "EURL": "Associé Unique",
          "SPA": "Institutionnel",
          "SAS": "Flexible"
        }
      },
      "warnings": {
        "critical_action": "ACTION CRITIQUE",
        "irrevocable": "Cette action est irrévocable et sera enregistrée au journal officiel.",
        "irreversible": "Action Irréversible",
        "irreversible_desc": "Cette action mettra fin définitivement à l'activité de la société."
      },
      "placeholders": {
        "generic_config": "Aucune configuration spécifique requise pour cet acte.",
        "no_changes": "Aucun changement détecté dans la configuration actuelle."
      },
      "buttons": {
        "confirm_understanding": "Je comprends et je confirme",
        "confirmed": "Confirmé",
        "processing": "Traitement en cours...",
        "finish": "Terminer et Enregistrer"
      },
      "validation": {
        "statutory": "Conformité Statutaire",
        "cnrc": "Registre du Commerce (CNRC)",
        "tax": "Éligibilité Fiscale",
        "valid": "VALIDE",
        "compliant": "CONFORME",
        "ready": "PRÊT",
        "ready_signature": "Prêt pour Signature",
        "no_blockage": "Aucun blocage juridique détecté."
      },
      "execution": {
        "title": "Confirmer & Exécuter",
        "desc": "Mettre à jour les données et générer les certificats."
      },
      "errors": {
        "address_required": "L'adresse précise est requise",
        "capital_invalid": "Montant du capital invalide",
        "form_required": "Veuillez choisir une forme juridique valide",
        "name_required": "Le nom de l'associé est requis",
        "confirm_dissolution": "Veuillez confirmer la décision de dissolution",
        "confirm_liquidation": "Veuillez confirmer la clôture de liquidation"
      },
      "toasts": {
        "recorded_title": "Acte Enregistré",
        "recorded_msg": "La modification a été enregistrée au registre de la société.",
        "failed_title": "Contrôle Échoué",
        "missing_field": "Champ Manquant"
      }
    },
    "dossier_pdf": {
      "title": "DOSSIER NUMÉRIQUE DE LA SOCIÉTÉ",
      "generated_at": "Généré le {{date}}",
      "identity": {
        "title": "1. IDENTITÉ DE LA SOCIÉTÉ",
        "name": "Dénomination :",
        "legal_form": "Forme Juridique :",
        "capital": "Capital Social :",
        "hq": "Siège Social :",
        "unspecified": "Non spécifié"
      },
      "governance": {
        "title": "2. GOUVERNANCE ET ASSOCIÉS",
        "header_name": "Nom",
        "header_role": "Rôle",
        "header_shares": "Parts",
        "header_contribution": "Apport",
        "role_manager": "Gérant",
        "role_gm": "Directeur Général",
        "role_partner": "Associé",
        "empty": "Aucun associé enregistré"
      }
    }
  },
  "simulator": {
    "structures": {
      "EURL": {
        "label": "EURL",
        "description": "Entreprise Unipersonnelle à Responsabilité Limitée"
      },
      "SARL": {
        "label": "SARL",
        "description": "Société à Responsabilité Limitée"
      },
      "SPA": {
        "label": "SPA",
        "description": "Société par Actions"
      },
      "SAS": {
        "label": "SAS",
        "description": "Société par Actions Simplifiée"
      },
      "SNC": {
        "label": "SNC",
        "description": "Société en Nom Collectic"
      },
      "INDIVIDUELLE": {
        "label": "Entreprise Individuelle",
        "description": "Personne Physique / Freelance"
      }
    },
    "title": "Simulateur Fiscal & Social",
    "subtitle": "Configurez votre structure en 4 étapes simples.",
    "steps": {
      "project": "Votre Projet",
      "project_desc": "Commençons par les bases de votre future activité.",
      "structure": "Structure & Capital",
      "structure_desc": "Définissez la taille et les ressources de votre entité.",
      "vision": "Vision & Risques",
      "vision_desc": "Affinez les objectifs stratégiques de la simulation.",
      "ready": "Configuration Prête",
      "ready_desc": "Vérifiez vos paramètres avant de lancer l'arbitrage."
    },
    "fields": {
      "activity_sector": "Secteur d'activité",
      "simulation_mode": "Mode de Simulation",
      "partners": "Nombre d'associés",
      "partner_label": "Associé",
      "partners_label": "Associés",
      "capital": "Capital de départ (DA)",
      "objective": "Objectif Principal",
      "risk": "Risque estimé",
      "investors": "Investisseurs ?",
      "currency": "DA"
    },
    "options": {
      "services": "Services",
      "commerce": "Commerce",
      "industry": "Industrie",
      "artisanat": "Artisanat",
      "startup": "Tech / Startup",
      "standard": "Standard (Légal)",
      "premium": "Premium (Bientôt)",
      "growth": "Croissance Rapide",
      "growth_desc": "Focus sur l'expansion et le marché",
      "stability": "Sécurité & Stabilité",
      "stability_desc": "Protection maximale du patrimoine",
      "tax_optimization": "Optimisation Fiscale",
      "tax_optimization_desc": "Réduction de la pression fiscale",
      "low": "Bas",
      "medium": "Moyen",
      "high": "Haut",
      "yes": "OUI",
      "no": "NON"
    },
    "summary": {
      "activity": "Activité",
      "partners": "Associés",
      "capital": "Capital Initial",
      "priority": "Priorité"
    },
    "buttons": {
      "reset": "Réinitialiser",
      "calculate": "Calculer les indicateurs",
      "previous": "Précédent",
      "continue": "Continuer",
      "run": "Lancer la Simulation",
      "executing": "Exécution..."
    },
    "footer": {
      "certification": "IA Decision Support System — Certified DZ_LAW_2025"
    },
    "info": "En lançant cette simulation, notre moteur traitera 150+ variables juridiques basées sur le Code de Commerce algérien pour vous proposer la structure optimale.",
    "engine": {
      "forms": {
        "EURL": {
          "name": "EURL",
          "desc": "Entreprise Unipersonnelle à Responsabilité Limitée. Idéale pour les fondateurs solos souhaitant limiter leur responsabilité."
        },
        "SARL": {
          "name": "SARL",
          "desc": "Société à Responsabilité Limitée. Standard pour plusieurs associés avec des actifs protégés."
        },
        "SPA": {
          "name": "SPA",
          "desc": "Société par Actions. Conçue pour les capitaux importants et les investisseurs externes."
        },
        "SAS": {
          "name": "SAS",
          "desc": "Société par Actions Simplifiée. Gouvernance flexible, excellente pour les startups."
        },
        "SNC": {
          "name": "SNC",
          "desc": "Société en Nom Collectif. Responsabilité solidaire et indéfinie, adaptée aux entreprises familiales de grande confiance."
        },
        "INDIVIDUELLE": {
          "name": "Entreprise Individuelle",
          "desc": "Création simple, mais responsabilité personnelle indéfinie."
        }
      },
      "reasons": {
        "partners_min": "Le nombre d'associés est inférieur au minimum légal.",
        "partners_max": "Le nombre d'associés dépasse le maximum légal.",
        "capital_min": "Le capital est inférieur au minimum légal requis.",
        "capital_ok": "Le capital social est conforme aux exigences légales.",
        "risk_limited": "La responsabilité limitée est idéale pour votre profil de risque.",
        "risk_unlimited": "Responsabilité illimitée : risque élevé pour vos biens personnels.",
        "risk_incompatible": "Risque élevé : vos biens personnels ne sont pas protégés.",
        "investor_ready": "Capacité à accueillir des investisseurs institutionnels.",
        "investor_unready": "Structure peu adaptée aux investisseurs externes.",
        "partners_ok": "Le nombre d'associés est conforme.",
        "protected_assets": "Votre patrimoine personnel est légalement protégé.",
        "startup_framework": "Cadre juridique spécifiquement adapté aux Startups labellisées.",
        "partners_1": "Structure optimisée pour un fondateur unique.",
        "partners_multi": "Gouvernance conçue pour plusieurs associés.",
        "partners_spa_min": "Répond à l'exigence minimale de 7 actionnaires pour une SPA.",
        "capital_1m": "Le capital atteint le seuil institutionnel (> 1M DZD).",
        "capital_100k": "Capital standard pour une SARL (> 100k DZD).",
        "tax_opt": "Régime fiscal optimisé pour ce secteur d'activité.",
        "asset_shield": "Séparation juridique complète des patrimoines personnel et professionnel.",
        "investor_fit": "Structure de capital évolutive pour des levées de fonds externes.",
        "growth_engine": "Gouvernance flexible soutenant une expansion rapide.",
        "governance_flex": "Faibles contraintes administratives pour la gestion quotidienne."
      },
      "explanations": {
        "DEFAULT": "Structure peu adaptée à votre projet actuel.",
        "EURL_SINGLE_PARTNER": "Choix optimal pour un associé unique souhaitant limiter sa responsabilité au capital social.",
        "EURL_RECOMMENDED": "Recommandé : l'EURL offre une protection professionnelle pour votre aventure en solo.",
        "INDIVIDUELLE_SINGLE_PARTNER": "Structure la plus souple pour un entrepreneur solo, sans capital minimum légal strict.",
        "INDIVIDUELLE_RECOMMENDED": "Simple et direct, parfait pour les micro-enterprises.",
        "SARL_PME": "La structure standard pour les PME en Algérie, offrant un équilibre entre coût et protection.",
        "SARL_RECOMMENDED": "Recommandé : la SARL équilibre parfaitement protection juridique et flexibilité pour votre projet.",
        "SARL_VIABLE": "Option viable, mais peut être moins optimisée que le choix principal pour votre profil.",
        "SAS_STARTUP": "Idéal pour une startup : flexibilité contractuelle totale et attractivité pour les investisseurs.",
        "SAS_SINGLE_PARTNER": "Idéal pour un fondateur de startup solo : flexibilité contractuelle totale.",
        "SAS_RECOMMENDED": "Moderne et flexible, idéal pour l'innovation et la montée en charge.",
        "SPA_LARGE": "Conçue pour les projets de grande envergure avec appel public à l'épargne ou capital important.",
        "SPA_RECOMMENDED": "Cadre institutionnel pour les projets à forte croissance ou capital élevé.",
        "SNC_TRUST": "Structure basée sur la confiance, adaptée aux projets familiaux ou artisanaux.",
        "SNC_RECOMMENDED": "Structure simple basée sur la confiance mutuelle entre associés.",
        "SCS_HYBRID": "Structure hybride permettant de dissocier gestionnaires et financeurs.",
        "SCS_RECOMMENDED": "Permet d'accueillir des investisseurs passifs tout en gardant le contrôle de la gestion.",
        "EURL_SOLO": "L'EURL est le véhicule le plus sûr pour les entrepreneurs solos. Elle permet un contrôle total tout en protégeant le patrimoine personnel.",
        "SARL_STANDARD": "La SARL reste la colonne vertébrale de l'économie algérienne. Elle offre un cadre robuste pour les partenariats et les PME.",
        "SPA_INSTITUTIONAL": "Conçue pour les opérations de grande envergure, la SPA offre la transparence et la structure nécessaires pour le capital institutionnel.",
        "SNC_PARTNERSHIP": "La SNC repose sur l'intuitu personae (confiance forte entre associés), offrant un cadre simplifié mais profondément engagé.",
        "SARL_TAX_EFFICIENT": "Cette configuration permet un équilibre optimisé entre l'impôt sur les sociétés et les dividendes des associés.",
        "EURL_PROTECTION": "Choisir une EURL garantit que les risques professionnels restent confinés dans les limites du capital de l'entreprise.",
        "SPA_INVESTOR": "La nature par actions de cette entité est parfaitement adaptée aux tables de capitalisation complexes et aux futures sorties."
      },
      "warnings": {
        "min_partners": "Minimum d'associés requis : {{value}}.",
        "max_partners": "Maximum d'associés dépassé (limite : {{value}}).",
        "low_capital_amount": "Capital inférieur au minimum statutaire ({{value}} DA).",
        "high_turnover": "Risque CA : Structure individuelle déconseillée pour de gros volumes.",
        "high_risk": "Critique : Les biens personnels sont exposés aux dettes sociales.",
        "no_investors": "Obstacle : Cette structure freine l'entrée de capital-risque."
      },
      "liability": {
        "limited": "Limitée",
        "unlimited": "Illimitée",
        "limited_to_shares": "Limitée aux Actions"
      },
      "risk_status": {
        "low": "Sécurisé",
        "medium": "Modéré",
        "high": "Critique"
      },
      "default_justification": "Cette structure offre le meilleur équilibre entre protection et coût."
    },
    "result": {
      "title": "Résultat de Simulation",
      "subtitle": "Analyse détaillée et recommandations juridiques basées sur vos paramètres.",
      "share": {
        "title": "Simulation de structure juridique - Charikaty",
        "text": "Découvrez mon arbitrage juridique généré par Charikaty.",
        "success": "Lien de simulation copié dans le presse-papier",
        "error": "Échec du partage"
      },
      "badge_ai": "PROPULSÉ PAR L'IA",
      "pdf": {
        "generating": "Génération en cours...",
        "download": "Télécharger Rapport PDF",
        "header_subtitle": "MOTEUR D'ARBITRAGE JURIDIQUE V2.4",
        "reference": "RÉFÉRENCE : #{{ref}}",
        "date": "DATE : {{date}}",
        "main_title": "RAPPORT DÉCISIONNEL",
        "param_header": "Paramètre",
        "value_header": "Valeur Saisie",
        "section1_title": "1. RÉSUMÉ EXÉCUTIF",
        "summary_text": "Basé sur l'analyse algorithmique de vos paramètres, la structure recommandée est la {{fullName}} ({{name}}).",
        "match_score": "SCORE DE MATCH : {{score}}%",
        "tax_regime": "RÉGIME FISCAL : {{regime}}",
        "section2_title": "2. PARAMÈTRES DE SIMULATION",
        "param_partners": "Nombre d'associés",
        "param_capital": "Capital Social",
        "param_activity": "Type d'activité",
        "param_risk": "Niveau de Risque",
        "param_objective": "Objectif Stratégique",
        "param_investors": "Ouverture au capital",
        "risk_high": "Élevé",
        "risk_medium": "Modéré",
        "risk_low": "Faible",
        "yes": "OUI",
        "no": "NON",
        "section3_title": "3. ANALYSE COMPARATIVE & AVANTAGES",
        "pros_title": "Avantages de la structure :",
        "footer": "Page {{page}} sur {{total}} - Document généré par le système Charikaty GSD",
        "error": "Échec de la génération du PDF"
      },
      "optimal_arbitrage": "Arbitrage Optimal",
      "status": "Status: {{status}}",
      "optimal_description": "{{fullName}}. Cette structure est la plus adaptée pour un capital de {{capital}} DA avec {{partners}} associé(s).",
      "strategic_match": "Match Stratégique",
      "tax_regime": "Régime Fiscal",
      "liability": "Responsabilité",
      "risk_analysis": "Analyse de Risque",
      "risk_evaluation": "Évaluation de la conformité et exposition",
      "no_blocking_points": "Aucun point bloquant majeur identifié.",
      "complexity_index": "Indice de Complexité",
      "viability_score": "Score de Viabilité",
      "viability_trend": "+12% par rapport aux alternatives",
      "asset_protection": "Protection Actifs",
      "protection_max": "Maximale",
      "protection_partial": "Partielle",
      "capital_flexibility": "Flexibilité Capital",
      "flexibility_total": "Totale",
      "flexibility_medium": "Moyenne",
      "scale_potential": "Potentiel Scale",
      "scale_high": "Élevé",
      "scale_medium": "Modéré",
      "legal_interpretation": "Interprétation Juridique",
      "legal_intro": "D'après les dispositions du Code de Commerce Algérien, votre choix de {{name}} permet une responsabilité {{liability}}. {{justification}}",
      "strengths": "Points Forts (Alpha)",
      "weaknesses": "Contraintes & Limites",
      "recommended_actions": "Actions Recommandées",
      "implementation_roadmap": "Feuille de route pour l'implémentation",
      "roadmap": {
        "step1_title": "Statuts Notariés",
        "step1_desc": "Rédiger les statuts avec mention précise de l'objet social.",
        "step2_title": "Dépôt de Capital",
        "step2_desc": "Ouvrir un compte 'Société en formation' pour le blocage.",
        "step3_title": "Enregistrement CNRC",
        "step3_desc": "Procéder à l'immatriculation sous 30 jours."
      },
      "start_constitution": "Lancer la Constitution",
      "new_simulation": "Nouvelle Simulation",
      "algorithmic_confidence": "Confiance Algorithmique",
      "engine_certified": "Sovereign Engine v2.4 Certified",
      "print_report": "Imprimer Rapport",
      "benchmarks": "Benchmarks",
      "benchmarks_description": "Analyse comparative avec d'autres structures",
      "match": "de correspondance",
      "arbitrage_details": "Détails d'arbitrage"
    },
    "forms": {
      "EURL": {
        "name": "EURL",
        "fullName": "Entreprise Unipersonnelle à Responsabilité Limitée",
        "description": "La structure reine pour les entrepreneurs solo souhaitant protéger leur patrimoine.",
        "taxRegime": "IRG ou Option IBS",
        "pros": [
          "Protection totale du patrimoine personnel",
          "Transformation facile en SARL lors de l'arrivée d'associés",
          "Choix du régime fiscal (IDB possible)"
        ],
        "cons": [
          "Formalisme administratif (Statuts, Notaire, CNRC)",
          "Obligations comptables complètes",
          "Coût de création élevé (Notaire + BOAL)"
        ]
      },
      "SARL": {
        "name": "SARL",
        "fullName": "Société à Responsabilité Limitée",
        "description": "Idéale pour les PME familiales et les associations de 2 à 50 personnes.",
        "taxRegime": "IBS",
        "pros": [
          "Sécurité juridique maximale pour les associés",
          "Structure très connue des banques algériennes",
          "Cession de parts contrôlée (préserve l'esprit de famille)"
        ],
        "cons": [
          "Entrée de nouveaux investisseurs complexe (Agrément)",
          "Plafonnée à 50 associés",
          "Gérant responsable en cas de faute de gestion"
        ]
      },
      "SPA": {
        "name": "SPA",
        "fullName": "Société par Actions",
        "description": "La forme d'excellence pour les grandes entreprises et les projets de capitaux.",
        "taxRegime": "IBS",
        "pros": [
          "Crédibilité maximale auprès des grands comptes/État",
          "Cession d'actions libre et instantanée",
          "Accès possible à la bourse d'Alger"
        ],
        "cons": [
          "Capital minimum de 1.000.000 DA obligatoire",
          "Gouvernance lourde (Conseil d'Administration)",
          "Commissaire aux comptes obligatoire dès la création"
        ]
      },
      "SAS": {
        "name": "SAS",
        "fullName": "Société par Actions Simplifiée",
        "description": "Nouvelle forme flexible dédiée aux Startups labellisées en Algérie.",
        "taxRegime": "IBS (Exonérations Startup possibles)",
        "pros": [
          "Liberté contractuelle totale des statuts",
          "Idéale pour les levées de fonds successives",
          "Cumul possible avec le label Startup (avantages fiscaux)"
        ],
        "cons": [
          "Réservée aux startupers ou entreprises labellisées",
          "Nécessite une rédaction de statuts très précise",
          "Structure encore \"jeune\" pour certaines banques localement"
        ]
      },
      "SNC": {
        "name": "SNC",
        "fullName": "Société en Nom Collectif",
        "description": "Une société de personnes basée sur la confiance mutuelle totale.",
        "taxRegime": "IRG (Transparence fiscale)",
        "pros": [
          "Aucun capital minimum réel requis",
          "Pas d'obligation de publier les comptes annuels",
          "Image de solidarité forte face aux créanciers"
        ],
        "cons": [
          "Responsabilité illimitée et solidaire sur les biens personnels",
          "Risque maximal : si un associé fait faillite, tous paient",
          "Difficile de sortir de la société sans accord unanime"
        ]
      },
      "INDIVIDUELLE": {
        "name": "E.I / Freelance",
        "fullName": "Entreprise Individuelle (Personne Physique)",
        "description": "La simplicité administrative absolue pour démarrer seul.",
        "taxRegime": "IFU (Impôt Forfaitaire Unique)",
        "pros": [
          "Création instantanée au CNRC (juste une carte)",
          "Coût de gestion quasi nul",
          "Comptabilité super-simplifiée"
        ],
        "cons": [
          "Patrimoine personnel et professionnel confondus",
          "Impossible d'avoir des associés par la suite",
          "Crédibilité limitée pour les gros contrats"
        ]
      }
    }
  },
  "name_check": {
    "title": "Validation de Marque",
    "subtitle": "Analyse comparative multi-vectorielle pour sécuriser votre identité commerciale.",
    "brand_arbitrage": "Arbitrage de Marque",
    "description": "Système expert de vérification de disponibilité et d'analyse des risques de confusion juridique selon les normes CNRC.",
    "multi_layer_audit": "Audit Multi-Couches",
    "check_1": "Disponibilité au Registre Central",
    "check_2": "Similarité Phonétique & Visuelle",
    "check_3": "Conformité Lexicale Arabe/FR",
    "check_4": "Analyse de Protection de Marque",
    "step1_label": "Dénomination Souhaitée",
    "name_placeholder": "EX: ALGERIA TECH SOLUTIONS",
    "step2_label": "Secteur d'Activité",
    "sectors": {
      "tech": "Technologie & Digital",
      "telecom": "Télécommunications",
      "finance": "Banque & Finance",
      "industry": "Industrie & Énergie",
      "construction": "BTP & Construction",
      "services": "Services aux Entreprises",
      "health": "Santé & Pharma",
      "trade": "Commerce & Distribution",
      "agro": "Agro-alimentaire",
      "other": "Autres Secteurs"
    },
    "step3_label": "Détails du Projet (Optionnel)",
    "details_placeholder": "Décrivez brièvement l'activité pour affiner l'analyse de risque...",
    "analyze_button": "Lancer l'Audit LegalEngine",
    "checking": "Audit en cours...",
    "database_info": "Base de données synchronisée CNRC",
    "compliance_guarantee": "Contrôle de conformité garanti",
    "connected_to": "Connecté au",
    "central_registry": "Registre Central du Commerce",
    "errors": {
      "reserved": "Ce nom est actuellement réservé dans votre session active."
    },
    "engine": {
      "explanation": {
        "unavailable": "Ce nom présente un conflit direct ou une similarité critique avec une entité existante au CNRC.",
        "risky": "Nom disponible mais présentant des risques de confusion modérés. Une modification légère est conseillée.",
        "available": "Excellente disponibilité. Aucun conflit majeur détecté dans le secteur sélectionné."
      }
    },
    "results": {
      "title": "Résultats de l'Analyse",
      "availability": "Disponibilité",
      "risk_level": "Niveau de Risque",
      "recommendation": "Recommandation",
      "risk_levels": {
        "low": "Risque Faible",
        "medium": "Risque Modéré",
        "high": "Risque Élevé"
      },
      "distinctiveness_levels": {
        "high": "Distinctivité Élevée",
        "low": "Distinctivité Faible"
      },
      "metrics": {
        "phonetic": "Phonétique",
        "phonetic_value": "{{percent}}% Match",
        "visual": "Visuel",
        "visual_value": "{{percent}}% Match"
      },
      "recommendations": {
        "ACCEPT": "Accepter",
        "MODIFY": "Modifier",
        "REJECT": "Rejeter"
      }
    }
  },
  "name_result": {
    "title": "Rapport d'Audit Sentinel",
    "subtitle": "Analyse d'éligibilité et de protection de la marque.",
    "status_valid": "Valide / Disponible",
    "status_invalid": "Indisponible / Risqué",
    "compiling": "Compilation de l'Analyse...",
    "recommended_action": "Action Recommandée",
    "digital_assets": "Actifs Digitaux & Domaines",
    "footer_advisory": "Ce rapport est généré à titre informatif par LegalEngine et ne remplace pas le certificat officiel du CNRC.",
    "summary": {
      "title": "Synthèse de l'Audit",
      "subtitle": "Indicateurs clés de performance et de conformité.",
      "legal_risk": "Risque Juridique",
      "phonetic": "Conflit Phonétique",
      "visual": "Conflit Visuel",
      "metric": "Métrique",
      "score": "Score de Marque",
      "description": "Description",
      "class": "Classe",
      "sector": "Secteur d'Activité",
      "distinctiveness": "Force Distinctive"
    },
    "conflicts": {
      "title": "Conflits Identifiés",
      "entity": "Entité",
      "similarity": "Similarité",
      "sector": "Secteur",
      "registered": "Déjà Enregistré",
      "match": "Correspondance"
    },
    "decision": {
      "title": "Décision Recommandée"
    },
    "domains": {
      "free": "Disponible",
      "taken": "Déjà pris",
      "global_asset": "Actif Global"
    },
    "actions": {
      "new_search": "Nouvelle recherche",
      "reserve": "Réserver ce nom",
      "excel": "Télécharger Excel",
      "pdf": "Télécharger PDF",
      "download_pdf": "Télécharger Rapport PDF",
      "download_excel": "Exporter Données"
    },
    "metrics": {
      "memorability": "Mémorabilité",
      "memorability_desc": "Capacité du public à retenir le nom.",
      "protection": "Indice de Protection",
      "protection_desc": "Force juridique de la marque.",
      "availability": "Disponibilité Immédiate",
      "availability_desc": "Statut actuel dans le registre national."
    },
    "similarity": "Similarité",
    "engine_status": "Sentinel v4.2 • LegalEngine Actif",
    "analysis": {
      "title": "Analyse Détaillée Sentinel",
      "description": "Notre moteur d'IA analyse le nom proposé par rapport aux registres du commerce et marques déposées."
    },
    "toasts": {
      "reserve_success_title": "Nom Réservé",
      "reserve_success_msg": "Le nom est désormais réservé pour votre projet."
    }
  },
  "create": {
    "title": "Création d'Entreprise",
    "subtitle": "Lancez votre structure avec une précision institutionnelle.",
    "steps": {
      "founder": "Fondateur",
      "structure": "Structure",
      "review": "Révision"
    },
    "buttons": {
      "next": "Étape Suivante",
      "back": "Retour",
      "submit": "Soumettre la Demande"
    }
  },
  "statutes": {
    "title": "Génération de Statuts Numériques",
    "subtitle": "Statuts certifiés par l'IA LegalEngine",
    "sections": {
      "social_object": "Objet Social",
      "share_capital": "Capital Social",
      "duration": "Durée",
      "headquarters": "Siège Social",
      "governance": "Gouvernance",
      "fiscal_year": "Exercice Social",
      "liquidation": "Liquidation",
      "partners": "Associés & Apports"
    },
    "actions": {
      "download_pdf": "Télécharger les Statuts (PDF)",
      "edit": "Modifier les Données",
      "validate": "Valider chez le Notaire"
    },
    "metadata": {
      "jurisdiction": "Juridiction",
      "framework": "Cadre Juridique",
      "algeria": "Algérie",
      "commercial_code": "Code de Commerce 2024",
      "certified_by": "Certifié par Charikaty GSD"
    }
  },
  "statutes_generator": {
    "title": "Générateur de Statuts",
    "subtitle": "Personnalisez et générez les statuts de votre entreprise en un clic.",
    "sections": {
      "structure": "Structure & Identité",
      "governance": "Gouvernance & Management",
      "capital": "Capital & Actionnariat",
      "compliance": "Audit de Conformité"
    },
    "fields": {
      "legal_form": "Forme Juridique Mandataire",
      "company_name": "Dénomination Sociale",
      "company_name_placeholder": "EX: SARL ALPHA DZ",
      "activity": "Objet Social (Activité Principale)",
      "activity_placeholder": "Décrivez l'activité économique de la société...",
      "address": "Siège Social (Adresse complète)",
      "address_placeholder": "Adresse, Commune, Wilaya",
      "manager_name": "Nom du Gérant / Directeur",
      "manager_placeholder": "Nom et prénom complet...",
      "powers": "Pouvoirs du Gérant",
      "powers_standard": "Les pouvoirs les plus étendus pour agir au nom de la société.",
      "powers_limited": "Pouvoirs limités aux actes de gestion courante.",
      "powers_secured": "Co-signature obligatoire pour tout acte > 500.000 DA.",
      "powers_standard_text": "Les pouvoirs les plus étendus pour agir au nom de la société.",
      "powers_limited_text": "Pouvoirs limités aux actes de gestion courante.",
      "powers_secured_text": "Co-signature obligatoire pour tout acte > 500.000 DA.",
      "capital": "Capital Social (DA)",
      "share_value": "Valeur Part / Action (DA)",
      "partners_list": "Liste des Associés / Actionnaires",
      "partner_badge": "Associé #{{index}}",
      "partner_name_placeholder": "Nom de l'associé...",
      "partner_id_placeholder": "N° Identité / Passeport...",
      "risk_level": "Niveau de Risque",
      "risk_prudent": "Prudent",
      "risk_moderate": "Modéré",
      "risk_aggressive": "Agressif",
      "threshold": "Seuil de Contrôle",
      "spas_options": "Paramètres Avancés (SPAS)"
    },
    "defaults": {
      "activity": "NÉGOCE ET SERVICES",
      "role": "Actionnaire",
      "category_founder": "FONDATEUR",
      "role_manager": "Gérant"
    },
    "validations": {
      "compliant": "Données conformes à la loi",
      "correction": "Corrections nécessaires",
      "success_msg": "Tous les éléments sont valides. Vous pouvez continuer.",
      "name_required": "Dénomination sociale requise",
      "name_short": "Dénomination trop courte pour le CNRC",
      "capital_zero": "Le capital doit être supérieur à 0",
      "shares_mismatch": "Répartition incohérente : {{total}}% (Doit être 100%)",
      "eurl_unipersonal": "L'EURL est strictement unipersonnelle",
      "spa_capital_min": "Le capital minimum pour une SPA est de 1.000.000 DA",
      "spa_partners_min": "Une SPA requiert au minimum 7 actionnaires",
      "sarl_partners_max": "Une SARL ne peut dépasser 50 associés",
      "manager_required": "Représentant légal (Gérant/Président) requis"
    },
    "buttons": {
      "reset": "Réinitialiser",
      "generate": "Générer le document",
      "balance": "Équilibrer Parts",
      "add_partner": "Ajouter Associé"
    },
    "toasts": {
      "processing_title": "Traitement en cours",
      "processing_msg": "Génération des statuts officiels...",
      "error_title": "Erreur de Génération",
      "error_msg": "Une erreur est survenue lors du traitement des données.",
      "success_title": "Données Générées",
      "success_msg": "Le projet de statuts a été préparé avec succès."
    },
    "actions": {
      "reset": "Réinitialiser",
      "generate": "Générer les documents"
    },
    "company_data": "Données de la Société",
    "legal_form_label": "Forme Juridique",
    "company_name_label": "Dénomination Sociale",
    "company_name_placeholder": "Ex: TechNova Solutions...",
    "activity_label": "Objet Social (Activités)",
    "activity_placeholder": "Décrivez l'activité de la société en détail...",
    "address_label": "Siège Social",
    "address_placeholder": "Adresse complète et Wilaya...",
    "validation": {
      "required": "Ce champ est obligatoire",
      "shares_sum": "La somme des parts doit être de 100% (Actuellement: {{total}}%)",
      "min_capital": "Le capital minimum pour cette forme est de {{min}} DA"
    },
    "setup": "Article"
  },
  "compliance": {
    "title": "Module de Conformité",
    "subtitle": "Surveillance en temps réel de votre statut réglementaire.",
    "status": {
      "title": "Statut de Conformité",
      "compliant": "Conforme",
      "non_compliant": "Non Conforme",
      "at_risk": "À Risque",
      "risk_negligible": "Négligeable",
      "risk_critical": "Critique",
      "risk_moderate": "Modéré",
      "risk_level": "Niveau de risque : {{level}}",
      "access_registry": "Accéder au Registre",
      "health_index": "Indice de Santé",
      "active_alerts": "Alertes Actives",
      "immediate_attention": "Attention immédiate requise",
      "next_deadlines": "Prochaines Échéances",
      "current_cycle": "Cycle actuel"
    },
    "registry": {
      "title": "Registre des Obligations",
      "filter_placeholder": "Filtrer les obligations...",
      "priority": "Priorité",
      "deadline": "Échéance",
      "penal_risk": "Risque Pénal",
      "action_start": "Démarrer",
      "actionLabel": "Démarrer"
    },
    "tasks": {
      "title": "Obligation",
      "social_accounts": {
        "title": "Dépôt des Comptes Sociaux",
        "desc": "Dépôt annuel obligatoire des comptes au CNRC avant le 30 juin.",
        "basis": "Art. 717 du Code de Commerce",
        "penalty": "Amendes et blocage RC"
      },
      "g50": {
        "title": "Déclaration G50 (Mensuelle)",
        "desc": "Déclaration et paiement des impôts (TAP, TVA, IRG, IBS).",
        "basis": "Code des Impôts Directs",
        "penalty": "Pénalités de retard (10-25%)"
      },
      "bank_dossier": {
        "title": "Mise à jour Dossier Bancaire",
        "desc": "Renouvellement des documents KYC auprès de votre banque.",
        "basis": "Règlement 02-11 de la Banque d'Algérie",
        "penalty": "Gel des opérations bancaires"
      },
      "ago": {
        "title": "Tenue de l'AGO Annuelle",
        "desc": "Assemblée Générale Ordinaire pour l'approbation des comptes.",
        "basis": "Art. 675 du Code de Commerce",
        "penalty": "Nullité des décisions sociales"
      },
      "das": {
        "title": "Déclaration DAS (Annuelle)",
        "desc": "Déclaration Annuelle des Salaires et des cotisations sociales.",
        "basis": "Loi 83-14 relative à la Sécurité Sociale",
        "penalty": "Amendes par salarié non déclaré"
      }
    },
    "form": {
      "title": "Titre",
      "description": "Description",
      "category": "Catégorie",
      "placeholder_title": "ex: Cotisation CASNOS",
      "placeholder_desc": "Entrez les détails de l'obligation..."
    },
    "priorities": {
      "CRITIQUE": "CRITIQUE",
      "HAUTE": "HAUTE",
      "MOYENNE": "MOYENNE",
      "FAIBLE": "FAIBLE"
    },
    "categories": {
      "JURIDIQUE": "JURIDIQUE",
      "FISCAL": "FISCAL",
      "SOCIAL": "SOCIAL",
      "ADMIN": "ADMIN"
    },
    "audit": {
      "title": "Traçabilité & Audit",
      "validated_event": "Événement Validé",
      "agent": "Agent : {{user}}",
      "id": "RÉFÉRENCE AUDIT",
      "empty": "Aucun historique d'audit disponible",
      "download": "Télécharger le Rapport",
      "system_init": "Système de Conformité Initialisé",
      "baseline_scan": "Scan réglementaire de base terminé"
    },
    "toasts": {
      "admin": "Administrateur Système",
      "resolved_title": "Obligation Résolue",
      "resolved_msg": "L'obligation a été marquée comme terminée. Réf: {{ref}}",
      "added": "Nouvelle obligation ajoutée au registre",
      "log_msg": "Action effectuée : {{title}}"
    },
    "intelligence": {
      "title": "Intelligence Réglementaire",
      "real_time": "TEMPS RÉEL",
      "break_point": "Point de rupture détecté",
      "break_point_desc": "Votre score de conformité est <1>inférieur à 60%</1>. Une régularisation immédiate du <3>Dossier Bancaire</3> est impérative.",
      "start_regularization": "Lancer la régularisation",
      "secure_perimeter": "Périmètre Sécurisé",
      "secure_desc": "Aucune anomalie critique détectée. Votre structure est en pleine conformité avec les réglementations en vigueur."
    },
    "nav": {
      "overview": "Vue d'ensemble",
      "registry": "Registre",
      "intelligence": "Intelligence"
    }
  },
  "statutes_result": {
    "title": "Génération de Statuts Constitutifs",
    "subtitle": "Synthèse et documents officiels prêts pour la signature.",
    "actions": {
      "print": "Imprimer",
      "download_pdf": "Télécharger PDF",
      "share": "Partager",
      "archive": "Archiver",
      "export_excel": "Exporter Excel",
      "advanced_options": "Options Avancées",
      "view_docs": "Consulter Documentation"
    },
    "status": {
      "document_state": "État du Document",
      "cnrc_compliant": "CONFORME CNRC 2024",
      "automated": "Génération Automatisée",
      "accuracy": "Score de Précision Légale",
      "legal_notice": "Note Juridique",
      "legal_notice_text": "Ces statuts sont générés dynamiquement selon vos entrées. Ils doivent être validés par un notaire assermenté pour être exécutoires.",
      "legal_notice_warning": "Ce document constitue un projet de statuts certifié. Il doit être authentifié par un notaire agréé pour acquérir sa pleine valeur juridique.",
      "end_of_document": "FIN DU DOCUMENT CONSTITUTIF"
    },
    "signature": {
      "mention_approved": "LU ET APPROUVÉ",
      "partner_initials": "Paraphé par les Associés",
      "company_seal": "CACHET DE LA SOCIÉTÉ",
      "manager_signature": "Signature du Gérant"
    },
    "placeholders": {
      "name": "[DÉNOMINATION SOCIALE]",
      "activity": "[OBJET SOCIAL DÉTAILLÉ]",
      "address": "[SIÈGE SOCIAL COMPLET]",
      "representative": "[NOM DU GÉRANT]"
    },
    "initial_data": {
      "activity": "Objet Social",
      "complexity": "Modérée",
      "automation": "Avancée",
      "type": "Forme",
      "capital": "Capital",
      "partners": "Associés",
      "complexity_label": "Complexité",
      "automation_label": "Automatisation"
    },
    "articles": {
      "standard": {
        "art1_title": "Forme Juridique",
        "art1_content": "La société est constituée sous la forme de {{form}}, conformément aux dispositions du Code de Commerce algérien.",
        "art2_title": "Dénomination",
        "art2_content": "La dénomination sociale de la société est : {{name}}. Elle sera suivie ou précédée de la mention {{form}}.",
        "art3_title": "Siège Social",
        "art3_content": "Le siège social est fixé à : {{address}}. Il pourra être transféré par simple décision de la gérance.",
        "art4_title": "Objet Social",
        "art4_content": "La société a pour objet : {{activity}}, et plus généralement toutes opérations se rattachant à cet objet.",
        "art5_title": "Capital Social",
        "art5_content": "Le capital social est fixé à {{capital}} DA. Il est divisé en {{count}} parts sociales de {{value}} DA chacune.",
        "art6_title": "Gérance",
        "art6_content": "La société est dirigée par {{manager}}. {{powers}}",
        "art7_title": "Exercice Social",
        "art7_content": "L'exercice social commence le 1er janvier et se termine le 31 décembre de chaque année.",
        "art8_title": "Décisions Collectives",
        "art8_content": "Les décisions des associés sont prises en assemblée générale ou par consultation écrite.",
        "art9_title": "Répartition des Bénéfices",
        "art9_content": "Le bénéfice distribuable est réparti entre les associés proportionnellement à leurs apports.",
        "art10_title": "Dissolution",
        "art10_content": "La dissolution anticipée de la société peut être prononcée par décision des associés.",
        "art11_title": "Contestations",
        "art11_content": "Toutes les contestations relatives aux affaires sociales seront soumises aux tribunaux compétents."
      },
      "spas": {
        "art1_title": "Forme de SPAS",
        "art1_content": "La société {{name}} est une Société par Actions Simplifiée (SPAS), régie par les lois en vigueur.",
        "art2_title": "Objet de la SPAS",
        "art2_content": "L'objet social de la SPAS est : {{activity}}.",
        "art3_title": "Capital et Actions",
        "art3_content": "Le capital est de {{capital}} DA, composé d'actions de {{value}} DA.",
        "art4_title": "Actionnaires",
        "art4_content": "Les actionnaires fondateurs sont : {{partners}}.",
        "art5_title": "Présidence",
        "art5_content": "La société est représentée par un Président désigné dans les conditions prévues aux présents statuts.",
        "art6_title": "Complexité de Gouvernance",
        "art6_content": "La structure de gouvernance est de type {{complexity}}.",
        "art7_title": "Seuils de Contrôle",
        "art7_content": "Un contrôle spécifique est activé pour tout montant supérieur à {{threshold}} DA.",
        "art8_title": "Gestion des Risques",
        "art8_content": "Le niveau de risque opérationnel est défini comme {{risk}}.",
        "art9_title": "Transmission d'Actions",
        "art9_content": "Toute cession d'actions est soumise à l'agrément préalable de la collectivité des actionnaires.",
        "art10_title": "Assemblées d'Actionnaires",
        "art10_content": "Les actionnaires disposent d'un droit de vote proportionnel au nombre d'actions qu'ils détiennent.",
        "art11_title": "Clauses d'Inaliénabilité",
        "art11_content": "Les statuts peuvent prévoir l'inaliénabilité des actions pour une durée n'excédant pas dix ans.",
        "art12_title": "Dispositions Diverses",
        "art12_content": "Toutes autres dispositions sont réglées conformément au Code de Commerce."
      }
    },
    "pdf": {
      "institutional_header": "RÉPUBLIQUE ALGÉRIENNE DÉMOCRATIQUE ET POPULAIRE",
      "ministry_header": "MINISTÈRE DE LA JUSTICE - DIRECTION GÉNÉRALE DU REGISTRE DE COMMERCE",
      "main_title": "STATUTS CONSTITUTIFS",
      "generation_date": "Date de Génération",
      "ref": "Réf. Audit",
      "filename_prefix": "Statuts_",
      "footer_text": "Document certifié par Charikaty Legal Sentinel - Conformité Code de Commerce 2024",
      "company_name": "Dénomination Sociale",
      "legal_form": "Forme Juridique",
      "headquarters": "Siège Social",
      "capital": "Capital Social",
      "partners_table": {
        "name": "Nom de l'Associé",
        "identity": "Pièce d'Identité",
        "shares": "Parts",
        "contribution": "Apport (DA)"
      },
      "currency": "دج"
    },
    "excel": {
      "filename": "Audit_Statuts_{{name}}.xlsx",
      "sheet_name": "Statuts",
      "headers": {
        "article": "Article",
        "title": "Titre",
        "content": "Contenu"
      },
      "report_title": "RAPPORT DE STRUCTURE CONSTITUTIVE"
    },
    "toasts": {
      "archived_title": "Document Archivé",
      "archived_msg": "Le document a été sauvegardé dans votre coffre-fort numérique.",
      "shared_title": "Lien Copié",
      "shared_msg": "Le lien vers ce document a été copié dans le presse-papier.",
      "pdf_ready_title": "PDF Prêt",
      "pdf_ready_msg": "Vos statuts ont été générés et sont prêts au téléchargement.",
      "export_ready_title": "Export Réussi",
      "export_ready_msg": "Les données ont été exportées vers Excel.",
      "error_gen": "Erreur lors de la génération du PDF.",
      "error_export": "Erreur lors de l'export Excel.",
      "error_archive": "Erreur lors de l'archivage.",
      "error_no_data": "Aucune donnée de statuts trouvée."
    }
  },
  "documentation_modal": {
    "title": "Documentation Légale",
    "subtitle": "Guide de Conformité Algérie v2024.1",
    "search_placeholder": "Rechercher un article...",
    "warning_title": "Avertissement",
    "warning_text": "Ces informations sont fournies à titre indicatif et ne remplacent pas le conseil d'un expert juridique agréé.",
    "help_title": "Besoin d'aide ?",
    "help_text": "Contactez notre support juridique spécialisé.",
    "open_ticket": "Ouvrir un Ticket",
    "certified": "Certifié par Charikaty Legal",
    "download_guide": "Télécharger le Guide PDF",
    "sections": {
      "legal_framework": {
        "title": "Cadre Juridique Algérien",
        "items": {
          "commerce": "Code de Commerce : Les articles 544 et suivants définissent les formes sociales.",
          "decree": "Décret Exécutif n° 97-40 : Relatif aux critères de constitution des sociétés.",
          "startup": "Loi n° 22-09 : Relative à l'auto-entrepreneur et aux startups (SAS)."
        }
      },
      "notary_role": {
        "title": "Rôle du Notaire",
        "items": {
          "auth": "Authentification : Tout acte constitutif doit être passé devant notaire.",
          "deposit": "Dépôt Légal : Le notaire assure le dépôt des statuts au CNRC.",
          "publicity": "Publicité Légale : Insertion obligatoire au BOAL."
        }
      },
      "cnrc_steps": {
        "title": "Étapes au CNRC",
        "items": {
          "name": "Dénomination : Obtention du certificat négatif.",
          "registration": "Immatriculation : Dépôt du dossier complet au CNRC.",
          "card": "Carte Magnétique : Délivrance de l'extrait définitif."
        }
      }
    }
  },
  "creation": {
    "title": "Création d'Entreprise",
    "description": "Flux d'immatriculation et de constitution de nouvelles entités juridiques.",
    "pipeline": "Pipeline Venture",
    "immatriculation": "Immatriculation",
    "expert_advice": {
      "title": "Conseil Expert",
      "text": "\"L'immatriculation intervient officiellement 48h après la signature notariée.\""
    },
    "steps": {
      "identity": {
        "title": "Identité",
        "desc": "Nom & Type"
      },
      "headquarters": {
        "title": "Siège Social",
        "desc": "Localisation"
      },
      "governance": {
        "title": "Gouvernance",
        "desc": "Actionnariat"
      },
      "validation": {
        "title": "Validation",
        "desc": "Audit Juridique"
      }
    },
    "step1": {
      "title": "Identité Juridique",
      "subtitle": "Définissez la personnalité morale de votre entreprise.",
      "name_label": "Dénomination Commerciale",
      "name_reserved": "Nom Réservé",
      "name_placeholder": "EX: ALGERIA TECH HUB",
      "form_label": "Forme Juridique",
      "common_hint": "(La plus courante)",
      "selected_via_simulator": "Sélectionnée via simulateur",
      "sector_label": "Secteur Statutaire",
      "sector_placeholder": "EX: SERVICES NUMÉRIQUES"
    },
    "step2": {
      "title": "Siège & Capital",
      "subtitle": "Réalité immobilière et consistance financière du projet.",
      "wilaya_label": "Wilaya d'Immatriculation",
      "address_label": "Adresse Détaillée (Locale)",
      "address_placeholder": "NUMÉRO, RUE, QUARTIER, COMMUNE...",
      "address_hint": "Doit correspondre au contrat de bail (notarié ou sous seing privé).",
      "capital_label": "Capital Social (DZD)",
      "min_legal": "Minimum Légal",
      "capital_hint": "Pour une <1>{{type}}</1>, le dépôt du capital doit être justifié par un certificat bancaire.",
      "capital_guarantee": "Garantie du Capital",
      "capital_guarantee_desc": "Le capital social détermine la responsabilité des associés à hauteur de leurs apports."
    },
    "step3": {
      "title": "Gouvernance",
      "subtitle": "Architecture du capital et désignation des gérants.",
      "new_associate": "+ Nouvel Associé",
      "associate_name": "Nom de l'Associé",
      "name_placeholder": "NOM & PRÉNOM",
      "identity_label": "Identité (NIN / Passeport)",
      "identity_placeholder": "NUMÉRO D'IDENTITÉ",
      "shares_label": "Actions (%)",
      "executive_role": "Rôle Exécutif",
      "roles": {
        "gerant": "Gérant Principal",
        "associe": "Associé Simple",
        "dg": "Directeur Général (DG)"
      },
      "cap_table_title": "Analyse de la Cap Table",
      "total_distributed": "Total Distribué",
      "shares_warning": "Le total des actions doit être strictement égal à 100% pour la signature des statuts."
    },
    "step4": {
      "title": "Audit & Validation",
      "subtitle": "Vérification finale avant la génération des actes juridiques.",
      "compliance_rate": "Conformité",
      "summary": {
        "identity": "Identité",
        "capital": "Capital",
        "capital_desc": "Libération Totale",
        "governance": "Actionnariat",
        "governance_desc": "Gérance: {{manager}}"
      },
      "report_title": "Rapport Sentinel",
      "compliance_note": {
        "title": "Note de Conformité",
        "engine": "Sentinel Engine v2024.1",
        "description": "\"La configuration choisie respecte les articles 544 et suivants du Code de Commerce algérien. La signature électronique sera disponible dès validation de ce flux.\""
      },
      "audit_summary": {
        "title": "Audit Institutionnel",
        "health": "Index de Santé Juridique",
        "hint": "Cet index évalue la conformité réglementaire et la protection des actifs personnels."
      },
      "legal_note": {
        "title": "Note Juridique",
        "desc": "Les statuts générés suivront strictement les dispositions du Code de Commerce algérien 2024."
      },
      "status": {
        "in_progress": "Audit en Cours",
        "hint": "L'Audit Institutionnel est réalisé automatiquement à l'étape de validation."
      }
    },
    "footer": {
      "previous": "Précédent",
      "next": "Suivant",
      "submit": "Finaliser la Création",
      "progress": "Progression Pipeline"
    },
    "audit_labels": {
      "denomination": "Dénomination",
      "structure": "Structure Associative",
      "capital": "Capital Social",
      "distribution": "Prorata du Capital",
      "ready_audit": "Prêt pour audit",
      "required": "Requis",
      "validated": "Validé & Réservé",
      "partners_ok": "{{count}} Associés (OK)",
      "partners_range": "Min: {{min}}, Max: {{max}}",
      "capital_ok": "Conforme au Code",
      "capital_req": "Min: {{min}} DZD requis",
      "distribution_ok": "Répartition équilibrée",
      "distribution_fail": "Total: {{total}}%"
    }
  },
  "creation_result": {
    "title": "Synthèse de Création",
    "description": "Dossier de constitution validé et certifié par Charikaty Legal Sentinel.",
    "success_header": "Processus Initialisé",
    "entity_ready": "Votre entité juridique <1>{{name}}</1> est prête pour l'immatriculation.",
    "certified_dossier": "Dossier Certifié",
    "default_activity": "SERVICES GÉNÉRAUX",
    "country": "ALGERIE",
    "legal_form_label": "Forme Juridique",
    "capital_label": "Capital Social",
    "associates_table_title": "Tableau des Associés",
    "members_count": "{{count}} Membres",
    "compliance_title": "Conformité Légale",
    "audit_ref": "Référence Audit",
    "cnrc_verification": "Vérification CNRC",
    "certified": "Certifié",
    "wilaya": "Wilaya",
    "complete_dossier": "Dossier Complet",
    "complete_dossier_desc": "Tous les éléments requis pour l'immatriculation sont validés.",
    "next_steps_title": "Prochaines Étapes",
    "steps": {
      "statutes": {
        "title": "Génération des Statuts",
        "desc": "Rédaction automatique des statuts constitutifs."
      },
      "notary": {
        "title": "Signature Notariée",
        "desc": "Rendez-vous chez le notaire (Alger Center)."
      },
      "cnrc": {
        "title": "Immatriculation CNRC",
        "desc": "Obtention du Registre de Commerce définitif."
      }
    },
    "legal_note_title": "Note Juridique",
    "legal_note_desc": "La présente synthèse constitue un audit de pré-immatriculation. Les statuts générés seront conformes au Code de Commerce algérien v2024.",
    "actions": {
      "modify": "Modifier",
      "pdf": "PDF",
      "generate": "Générer Statuts"
    }
  },
  "creation_success": {
    "title": "Succès Institutionnel",
    "subtitle": "Votre architecture juridique a été générée et validée avec succès par le moteur LegalEngine.",
    "badge": "CERTIFIÉ PAR CHARIKATY",
    "summary_title": "Résumé de la Constitution",
    "company_name": "Dénomination",
    "legal_form": "Forme Juridique",
    "capital_label": "Capital Social",
    "associates_table_title": "Tableau des Associés",
    "members_count": "{{count}} Membres",
    "compliance_title": "Conformité Légale",
    "audit_ref": "Référence de l'Audit",
    "cnrc_verification": "Vérification CNRC",
    "certified": "Certifié",
    "wilaya": "Wilaya",
    "complete_dossier": "Dossier Complet",
    "complete_dossier_desc": "Tous les éléments requis pour l'immatriculation sont validés.",
    "next_steps_title": "Prochaines Étapes",
    "steps": {
      "statutes": {
        "title": "Génération des Statuts",
        "desc": "Rédaction automatique des statuts constitutifs."
      },
      "notary": {
        "title": "Signature Notariée",
        "desc": "Rendez-vous chez le notaire (Alger Centre)."
      },
      "cnrc": {
        "title": "Immatriculation CNRC",
        "desc": "Obtention du Registre du Commerce définitif."
      }
    },
    "legal_note_title": "Note Juridique",
    "legal_note_desc": "Ce résumé constitue un audit de pré-immatriculation. Les statuts générés seront conformes au Code de Commerce algérien v2024.",
    "actions": {
      "modify": "Modifier",
      "pdf": "PDF",
      "generate": "Générer Statuts"
    }
  }
}